/*need to fix this file for too many lines */
/* eslint max-lines: off */
/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import startCase from 'lodash/startCase';
import TextInput from './TextInput';
import TextArea from './TextArea';
import Switch from './Switch';
import Select from './Select';
import Rating from './Rating';
import Phone from './Phone';
import MultiSelect from './MultiSelect';
import Checkbox from './Checkbox';
import MultiOptions from './MultiOptions';
import MapArtist from './MapArtist';
import MapPolygon from './MapPolygon'; // TBRefactor
import PolygonCreator from './PolygonCreator'; // TBRefactor
import MediaUpload from './MediaUpload';
import BoolReadOnly from './BoolReadOnly';
import ArrayAddition from './ArrayAddition';
import MultiSelectInput from './MultiSelectInput';
import CustomSelect from './CustomSelect';
import SubCustomForm from './CustomSubForm/form';
import DateTimePicker from 'components/DateTimePicker/DatePicker';
import TimePicker from './TimePicker/TimePicker';
import SubPanel from './SubPanel';
import Address from './AddressAutoComplete';
import styles from './index.module.scss';
import SubForm from './SubForm';
import { ADDRESS_MARKER } from '../../../utils/constants/Map';
import EmbeddedForm from './EmbeddedForm';
import { isEmpty } from 'lodash';
import AsyncSelect from './AsyncSelect';
import FormDataPopulation from './FormDataPopulation';
import FormTabs from './FormTabs';
import Schedule from './Schedule';
import {
  getErrorValue,
  getFieldValue,
  getNestedValue,
} from 'utils/methods/helpers';
import ImageArtist from './ImageArtist/index';
import RadioButtonsGroup from '../../RadioButton/index';
import BooleanStatus from 'components/Details/BooleanStatus';
import { MediaUploadForm } from './MultiMediaUpload/index';
import Table from 'components/Table';
import EmbeddedFormFollowup from './EmbeddedFormFollowup/embeddedFormFollowup';
import DynamicTextGenerator from './DynamicTextGenerator/dynamicTextGenerator';
import Signature from './Signature/signature';
import CollectEvidence from './CollectEvidence/collectEvidence';
import { t } from 'i18next';
const FieldSelection = ({ id, item, key, props, viewName }) => {
  switch (item.type) {
    case 'text': {
      const error = getNestedValue({ item, data: props.errors });
      const touched = getNestedValue({ item, data: props.touched });
      return (
        <TextInput
          id={id ? `${id}-${item.field}` : item.field}
          label={item.label ? item.label : startCase(item.field)}
          className={cn(styles.textInput, styles[item.size])}
          key={key}
          required={item.required}
          type={item.fieldType}
          field={item.field}
          onChange={value => {
            if (item.fieldType === 'number') {
              props.setFieldValue(item.field, value); // do not use formik's props.handleChange with numbers
              // seems to have an issue with 0 value as it removes it from text field
              return;
            }

            props.handleChange(value);
          }}
          value={getFieldValue({ item, props, defaultValue: '' })}
          onFocus={() => props.setFieldTouched(item.field)}
          touched={props.touched[item.field]}
          placeholder={
            item.placeholder
              ? item.placeholder
              : `Enter ${startCase(item.field)}`
          }
          error={
            (touched && error) ||
            (error && props.submitCount > 0 ? error : false)
          }
          disabled={item.disabled}
          maxLength={item.maxLength}
          startAdornment={item.startAdornment}
          hidden={item.hidden}
          info={item.info}
          view={item?.view}
        />
      );
    }

    case 'text-translated': {
      const error = getNestedValue({ item, data: props.errors });
      const touched = getNestedValue({ item, data: props.touched });
      return (
        <TextInput
          id={id ? `${id}-${item.field}` : item.field}
          label={item.label ? item.label : startCase(item.field)}
          className={cn(styles.textInput, styles[item.size])}
          key={key}
          required={item.required}
          type={item.fieldType}
          field={item.field}
          onChange={value => {
            if (item.fieldType === 'number') {
              props.setFieldValue(item.field, value); // do not use formik's props.handleChange with numbers
              // seems to have an issue with 0 value as it removes it from text field
              return;
            }

            props.handleChange(value);
          }}
          value={t(getFieldValue({ item, props, defaultValue: '' }))}
          onFocus={() => props.setFieldTouched(item.field)}
          touched={props.touched[item.field]}
          placeholder={
            item.placeholder
              ? item.placeholder
              : `Enter ${startCase(item.field)}`
          }
          error={
            (touched && error) ||
            (error && props.submitCount > 0 ? error : false)
          }
          disabled={item.disabled}
          maxLength={item.maxLength}
          startAdornment={item.startAdornment}
          hidden={item.hidden}
          info={item.info}
          view={item?.view}
        />
      );
    }

    case 'checkbox-options': {
      const error = getErrorValue({ item, props });

      return (
        <Checkbox
          label={startCase(item.label || item.field)}
          className={cn(styles.textInput, styles[item.size])}
          formGroupClassName={cn({
            [styles.denseTop]: item.denseFormGroup,
          })}
          key={key}
          options={item.options}
          required={item.required}
          field={item.field}
          value={getFieldValue({ item, props, defaultValue: [] })}
          onFocus={() => props.setFieldTouched(item.field)}
          onChange={value => {
            props.setFieldValue(item.field, value);
          }}
          touched={props.touched[item.field]}
          error={
            (props.touched[item.field] && error) ||
            (error && props.submitCount > 0 ? error : false)
          }
          disabled={item.disabled}
          info={item.info}
          hide={item.hide}
          noOptionsText={item.noOptionsText}
        />
      );
    }
    case 'radio-buttons': {
      const error = getErrorValue({ item, props });
      return (
        <RadioButtonsGroup
          onChange={value => {
            props.setFieldValue(item.field, value);
          }}
          label={startCase(item.label || item.field)}
          value={getFieldValue({ item, props, defaultValue: [] })}
          options={item.options}
          touched={props.touched[item.field]}
          error={
            (props.touched[item.field] && error) ||
            (error && props.submitCount > 0 ? error : false)
          }
          disabled={item.disabled}
          info={item.info}
          hide={item.hide}
          noOptionsText={item.noOptionsText}
          item={item}
        />
      );
    }
    case 'textArea':
      return (
        <TextArea
          label={item?.label || startCase(item.field)}
          className={cn(styles.textInput, styles[item.size])}
          key={key}
          required={item.required}
          field={item.field}
          value={props.values[item.field]}
          maxLength={item.maxLength}
          onFocus={() => props.setFieldTouched(item.field)}
          onChange={props.handleChange}
          touched={props.touched[item.field]}
          disabled={item.disabled}
          placeholder={
            item.placeholder
              ? item.placeholder
              : `Enter details for ${item.field}`
          }
          error={
            (props.touched[item.field] && props.errors[item.field]) ||
            (props.errors[item.field] && props.submitCount > 0
              ? props.errors[item.field]
              : false)
          }
          info={item.info}
        />
      );

    case 'select': {
      const error = getErrorValue({ item, props });
      const getDefaultValue = (item, props) => {
        if (item?.showPopup && props?.initialValues?.siteSurfaceImages) {
          return props.initialValues.siteSurfaceImages.name;
        } else return '';
      };
      return (
        <Select
          key={key}
          multiple={item.multiple}
          disabled={item.disabled}
          name={item.field}
          nullable={item.nullable}
          label={item.label ? item.label : startCase(item.field)}
          className={cn(
            styles.textInput,
            styles.select,
            styles[item.size],
            styles[item.align],
          )}
          required={item.required}
          options={item.options}
          value={
            item?.multiple
              ? !props.values[item.field] && item.multiple
                ? []
                : props.values[item.field]
              : getFieldValue({
                  item,
                  props,
                  defaultValue: getDefaultValue(item, props),
                })
          }
          valueType={item.valueType}
          onChange={e => {
            if (item?.multiple) {
              props.setFieldValue(item.field, e);
            } else {
              props.handleChange(e);
            }

            if (Array.isArray(item.updateDependentField)) {
              item.updateDependentField.forEach(f => {
                if (
                  item?.multiple &&
                  typeof f.condition === 'function' &&
                  f.condition(item.field, props.values) &&
                  typeof props.setFieldValue === 'function' &&
                  !item.customSubForm
                ) {
                  props.setFieldValue([f.key], f.passValue);
                } else if (
                  typeof f.condition === 'function' &&
                  f.condition(e.target.value, props.values) &&
                  typeof props.setFieldValue === 'function' &&
                  !item.customSubForm // this means it is formik
                ) {
                  props.setFieldValue([f.key], f.passValue);
                } else if (
                  typeof f.condition === 'function' &&
                  f.condition(e.target.value, props.values) &&
                  item.customSubForm
                ) {
                  props.setValues(prev => ({
                    ...prev,
                    [f.key]: f.passValue,
                  })); // usestate for adding a key value to formik keys
                } else {
                  props.setValues(prev => ({
                    ...prev,
                    [f.key]: f.failValue,
                  }));
                }
              });
            }
          }}
          onFocus={() => props.setFieldTouched(item.field)}
          error={
            (props.touched[item.field] && error) ||
            (error && props.submitCount > 0 ? error : false)
          }
          hidden={item.hidden}
          info={item.info}
          noOptionsText={item.noOptionsText}
          optionLabelKey={item.optionLabelKey}
          showPopup={item.showPopup}
          isMapTouched={
            /**
             * TODO: - Remove and replace with isSurfaceTouched
             */
            // if there are any checkpoints on the map, then pass true otherwise false
            props.values.checkpoints && props.values.checkpoints.length > 0
          }
          isSurfaceTouched={item.surfaceTouched}
          formProps={props}
          handleSelectChange={item.handleSelectChange}
        />
      );
    }

    case 'async-select':
      return (
        <AsyncSelect
          key={key}
          disabled={item.disabled}
          item={item}
          name={item.field}
          nullable={item.nullable}
          isMatch={item.isMatch} // if this flag is set then async will refetch the value
          label={item.label ? item.label : startCase(item.field)}
          className={cn(
            styles.textInput,
            styles.select,
            styles[item.size],
            styles[item.align],
          )}
          required={item.required}
          options={item.options}
          value={
            !props.values[item.field] && item.multiple
              ? []
              : props.values[item.field]
          }
          valueType={item.valueType}
          onChange={(value, name, reason) => {
            props.setFieldValue(item.field, value);
            if (typeof props.onAsyncChange === 'function') {
              props.onAsyncChange(value, name);
            }
            // if you want a dependent field to always change the value
            if (Array.isArray(item.updateDependentField)) {
              item.updateDependentField.forEach(f => {
                if (
                  typeof f.condition === 'function' &&
                  f.condition(item.field, props.values, value, reason) &&
                  typeof props.setFieldValue === 'function'
                ) {
                  props.setFieldValue([f.key], f.passValue);
                }
              });
            }
          }}
          resetWhen={item.resetWhen}
          onFocus={() => props.setFieldTouched(item.field)}
          error={
            (props.touched[item.field] && props.errors[item.field]) ||
            (props.errors[item.field] && props.submitCount > 0
              ? props.errors[item.field]
              : false)
          }
          formProps={props}
          hidden={item.hidden}
          info={item.info}
          noOptionsText={item.noOptionsText}
          optionLabelKey={item.optionLabelKey}
          fetchOptions={item.fetchOptions}
          onChangeCallback={item.onChangeCallback}
          fetchFilters={item.fetchFilters}
          multiple={item.multiple}
          dataTransform={item.dataTransform}
          limitTags={item.limitTags}
          fixedOptions={item.fixedOptions}
          setFormikFieldValues={keyValuePairs => {
            //This will help to reset/assign the dependent field values for the current field when the popup is closed
            for (const key in keyValuePairs) {
              if (Object.hasOwnProperty.call(keyValuePairs, key)) {
                const element = keyValuePairs[key];
                props.setFieldValue(key, element);
              }
            }
          }}
        />
      );
    case 'image-boolean':
      return (
        <BooleanStatus
          label={item.label}
          error={item.error}
          fieldSelection={item.fieldSelection}
          value={item.value}
          className={cn(
            styles.textInput,
            styles.select,
            styles[item.size],
            styles[item.align],
          )}
        />
      );

    case 'boolean-select':
      return (
        <Select
          key={key}
          name={item.field}
          label={item.label ? item.label : startCase(item.field)}
          className={cn(styles.textInput, styles[item.size])}
          required={item.required}
          options={[
            { name: 'YES', id: true },
            { name: 'NO', id: false },
          ]}
          value={props.values[item.field]}
          onChange={props.handleChange}
          onFocus={() => props.setFieldTouched(item.field)}
          error={
            (props.touched[item.field] && props.errors[item.field]) ||
            (props.errors[item.field] && props.submitCount > 0)
          }
        />
      );

    case 'toggle':
      return (
        <Switch
          key={key}
          label={item.label ? item.label : startCase(item.field)}
          checked={getFieldValue({ item, props, defaultValue: false })}
          onChange={e => {
            props.handleChange(e);
            if (Array.isArray(item.updateDependentField)) {
              item.updateDependentField.forEach(f => {
                if (typeof f.condition === 'function') {
                  f.condition(e.target.checked, props.values) &&
                    props.setFieldValue(f.key, f.value);
                  return;
                }
                props.setFieldValue(f.key, f.value);
              });
            }
          }}
          value={getFieldValue({ item, props, defaultValue: false })}
          name={item.field}
          className={cn(
            styles[item.size],
            styles[item.visibility],
            styles[item.alignment],
            styles[item.size],
          )}
          error={props.touched[item.field] && getErrorValue({ item, props })}
          title={startCase(item.field)}
          info={item.info}
          hidden={item.hidden}
          disabled={item.disabled}
          popUpRequired={item.popUpRequired}
          setFormikFieldValues={keyValuePairs => {
            for (const key in keyValuePairs) {
              if (Object.hasOwnProperty.call(keyValuePairs, key)) {
                const element = keyValuePairs[key];
                props.setFieldValue(key, element);
              }
            }
          }}
          popupMessagefields={item.popupMessagefields}
          formtype={item.formtype}
        />
      );

    case 'rating':
      return (
        <Rating
          key={key}
          required={item.required}
          className={cn(styles.textInput, styles[item.size])}
          label={item.label ? item.label : startCase(item.field)}
          onChange={value => {
            props.setFieldValue(item.field, value);
          }}
          value={props.values[item.field]}
          name={item.field}
          error={
            (props.touched[item.field] && props.errors[item.field]) ||
            (props.errors[item.field] && props.submitCount > 0)
          }
          hidden={item.hidden}
        />
      );

    case 'phone':
      return (
        <Phone
          secondaryOptions={item.secondaryOptions}
          secondaryFieldName={item.secondaryKey || 'country'}
          secondaryValue={props.values[item.secondaryKey || 'country']}
          key={key}
          required={item.required}
          onFocus={() => {
            props.setFieldTouched('country');
            props.setFieldTouched(item.field);
          }}
          className={cn(styles.textInput, styles[item.size])}
          label={startCase(item.field)}
          onChange={props.handleChange}
          value={props.values[item.field]}
          touched={props.touched[item.field]}
          placeholder={
            item.placeholder ? item.placeholder : 'Enter phone number'
          }
          name={item.field}
          error={
            (props.touched[item.field] && props.errors[item.field]) ||
            (props.errors[item.field] && props.submitCount > 0
              ? props.errors[item.field]
              : false)
          }
          hidden={item.hidden}
          disabled={item.disabled}
          info={item.info}
        />
      );

    case 'multiselect':
      return (
        <MultiSelect
          key={key}
          name={item.field}
          label={item.label ? item.label : startCase(item.field)}
          className={cn(styles.textInput, styles[item.size])}
          required={item.required}
          options={item.options}
          value={props.values[item.field]}
          onChange={props.handleChange}
          onFocus={() => props.setFieldTouched(item.field)}
          error={
            (props.touched[item.field] && props.errors[item.field]) ||
            (props.errors[item.field] && props.submitCount > 0
              ? props.errors[item.field]
              : false)
          }
          info={item.info}
        />
      );

    case 'multioptions':
      return (
        <MultiOptions
          key={key}
          size={item.size}
          keys={item.keys}
          name={item.field}
          label={item.label ? item.label : startCase(item.field)}
          required={item.required}
          optionTypes={item.optionTypes}
          value={props.values[item.field]}
          onChange={value => {
            props.setFieldValue(item.field, value);
          }}
          onFocus={() => props.setFieldTouched(item.field)}
          error={
            (props.touched[item.field] && props.errors[item.field]) ||
            (props.errors[item.field] && props.submitCount > 0)
          }
          info={item.info}
        />
      );

    case 'date-picker': {
      const touched = getNestedValue({ item, data: props.touched });
      const error = getNestedValue({ item, data: props.errors });
      return (
        <DateTimePicker
          key={key}
          className={cn(styles.textInput, styles[item.size])}
          onChange={value => {
            props.setFieldValue(item.field, value);
          }}
          label={item.label ? item.label : startCase(item.field)}
          value={getFieldValue({ item, props, defaultValue: undefined })}
          error={
            (touched && error) ||
            (error && props.submitCount > 0 ? error : false)
          }
          showDateTime={false}
          info={item.info}
          required={item.required}
        />
      );
    }
    case 'time': {
      const touched = getNestedValue({ item, data: props.touched });
      const error = getNestedValue({ item, data: props.errors });
      const timeValue = getFieldValue({ item, props, defaultValue: undefined });

      return (
        <TimePicker
          key={key}
          className={cn(styles.textInput, styles[item.size])}
          label={item.label ? item.label : startCase(item.field)}
          required={item.required}
          disabled={item.disabled}
          value={timeValue}
          onChange={value => {
            props.setFieldValue(item.field, value);
          }}
          error={
            (touched && error) ||
            (error && props.submitCount > 0 ? error : false)
          }
          info={item.info}
          timeInterval={item.timeInterval}
          maxMinuteInput={item.maxMinuteInput}
        />
      );
    }

    case 'datetime': {
      const touched = getNestedValue({ item, data: props.touched });
      const error = getNestedValue({ item, data: props.errors });

      return (
        <DateTimePicker
          key={key}
          minDate={item.minDate}
          maxDate={item.maxDate}
          required={item.required}
          className={cn(styles.textInput, styles[item.size])}
          label={item.label ? item.label : startCase(item.field)}
          onFocus={() => props.setFieldTouched(item.field)}
          value={getFieldValue({ item, props, defaultValue: undefined })}
          onChange={value => {
            props.setFieldValue(item.field, value);
          }}
          error={
            (touched && error) ||
            (error && props.submitCount > 0 ? error : false)
          }
          info={item.info}
          disabled={item.disabled}
          timeInterval={item.timeInterval}
          maxMinuteInput={item.maxMinuteInput}
        />
      );
    }

    case 'map-artist':
      return (
        <MapArtist
          key={key}
          required={item.required}
          label={item.label ? item.label : startCase(item.field)}
          value={props.values[item.field]}
          onChange={value => {
            props.setFieldValue(item.field, value);
          }}
          additionalPolygon={item.additionalPolygon}
          additionalPolygonMode={item.additionalPolygonMode}
          error={
            (props.touched[item.field] && props.errors[item.field]) ||
            (props.errors[item.field] && props.submitCount > 0
              ? props.errors[item.field]
              : false)
          }
          info={item.info}
          maxPoints={item.maxPoints}
          center={
            !isEmpty(props.values.mapMarker)
              ? {
                  lat: props.values.mapMarker[0].lat,
                  lng: props.values.mapMarker[0].lng,
                }
              : (props.values.locationDetail &&
                  props.values.locationDetail.center) ||
                item.center
          }
          centerDefault={item.centerDefault}
          singleMarkerIcon={item.singleMarkerIcon}
          formProps={props}
          locationEvidence={props.values.locationEvidence}
          requiredFields={item.requiredFields}
          displayEvidence={item.displayEvidence}
          disableMarkerClick={item.disableMarkerClick}
          disabled={item.disabled}
          polylineConfig={item.polylineConfig}
          hidePolylines={item.hidePolylines}
          iconTextType={item.iconTextType}
          additionalMarkers={props.values.additionalMarkers}
          typeOfIcon={item.typeOfIcon}
          mediaOnChange={value => {
            props.setFieldValue(item.field, value);
          }}
          viewName={viewName}
          displaySites={item.displaySites} // this will enable all sites to be shown on the maps
          patrolEvidenceOptions={item.patrolEvidenceOptions}
          uploadPatrolTask={item.uploadPatrolTask}
          evidenceCollection={item?.evidenceCollection}
          secondaryDetail={item.secondaryDetail}
        />
      );

    case 'image-artist':
      return (
        <ImageArtist
          required={item.required}
          label={item.label ? item.label : startCase(item.field)}
          value={props.values[item.field]}
          onChange={value => {
            props.setFieldValue(item.field, value);
          }}
          error={
            (props.touched[item.field] && props.errors[item.field]) ||
            (props.errors[item.field] && props.submitCount > 0
              ? props.errors[item.field]
              : false)
          }
          info={item.info}
          maxPoints={item.maxPoints}
          draggable={item.draggable}
          formProps={props}
          locationEvidence={props.values.locationEvidence}
          requiredFields={item.requiredFields}
          displayEvidence={item.displayEvidence}
          disableMarkerClick={item.disableMarkerClick}
          imageDimensions={value => {
            props.setFieldValue('imageDimensions', value);
          }}
          additionalMarkers={props.values.additionalMarkers}
          hidePolylines={item.hidePolylines}
          siteSurfaceImages={item.selectedSiteDetailImages}
          singleMarkerIcon={item.singleMarkerIcon}
          typeOfIcon={item.typeOfIcon}
          patrolEvidenceOptions={item.patrolEvidenceOptions}
          uploadPatrolTask={item.uploadPatrolTask}
          viewName={viewName}
        />
      );

    case 'map-polygon':
      return (
        <MapPolygon
          eventType={item.eventType === 'News' ? 'NEWS' : 'OTHERS'}
          key={key}
          required={item.required}
          label={item.label ? item.label : startCase(item.field)}
          primaryPolygon={props.values[item.field]}
          mapCentre={item.centreOfGravity} // centre of gravity of the map
          secondaryPolygons={item.secondaryPolygons}
          onChange={value => {
            props.setFieldValue(item.field, value);
          }}
          error={
            (props.touched[item.field] && props.errors[item.field]) ||
            (props.errors[item.field] && props.submitCount > 0
              ? props.errors[item.field]
              : false)
          }
          info={item.info}
        />
      );

    case 'polygon-creator': {
      let centerPoints = null;
      if (!isEmpty(props.values.mapMarker)) {
        /* eslint prefer-destructuring: ["error", {VariableDeclarator: {object: true}}] */
        centerPoints = props.values.mapMarker[0];
      } else if (props.values?.locationDetail?.center) {
        centerPoints = props.values.locationDetail.center;
      } else if (props.values?.centreOfGravity) {
        centerPoints = {
          lat: props.values.centreOfGravity.latitude,
          lng: props.values.centreOfGravity.longitude,
        };
      } else if (props.values?.boundary) {
        centerPoints = props.values.boundary.center;
      }
      return (
        <PolygonCreator
          center={centerPoints}
          eventType={item.eventType}
          key={key}
          requirePan={item.requirePan}
          markers={props.values.mapMarker}
          required={item.required}
          label={item.label ? item.label : startCase(item.field)}
          value={props.values[item.field]}
          onChange={value => {
            props.setFieldValue(item.field, value);
          }}
          setSecondaryValue={value => {
            props.setFieldValue(item.secondaryValue, value);
          }}
          error={
            (props.touched[item.field] && props.errors['paths']) ||
            (props.errors[item.field] && props.submitCount > 0
              ? props.errors[item.field]
              : false)
          }
          info={item.info}
          displaySites={item.displaySites}
        />
      );
    }

    case 'mediaUpload':
      return (
        <MediaUpload
          key={key}
          required={item.required}
          label={item.label ? item.label : startCase(item.field)}
          value={props.values[item.field]}
          onChange={value => {
            props.setFieldValue(item.field, value);
          }}
          error={
            (props.touched[item.field] && props.errors[item.field]) ||
            (props.errors[item.field] && props.submitCount > 0)
          }
          info={item.info}
          maxImageUpload={item.maxImageUpload}
        />
      );

    case 'arrayAddition':
      return (
        <ArrayAddition
          key={key}
          label={item.label ? item.label : startCase(item.field)}
          value={props.values[item.field]}
          onChange={value => {
            props.setFieldValue(item.field, value);
          }}
          error={
            (props.touched[item.field] && props.errors[item.field]) ||
            (props.errors[item.field] && props.submitCount > 0)
          }
        />
      );

    case 'multi-select-input':
      return (
        <MultiSelectInput
          key={key}
          required={item.required}
          exception={item.exception}
          label={item.label ? item.label : startCase(item.field)}
          selectedTypes={item.selectedTypes}
          value={props.values[item.field]}
          onChange={value => {
            props.setFieldValue(item.field, value);
          }}
          defaultValues={item.defaultValues}
          error={
            (props.touched[item.field] && props.errors[item.field]) ||
            (props.errors[item.field] && props.submitCount > 0)
          }
          info={item.info}
        />
      );

    case 'bool-read-only':
      return (
        <BoolReadOnly
          key={key}
          label={item.label ? item.label : startCase(item.field)}
          value={item.value}
        />
      );

    case 'custom-select':
      return (
        <CustomSelect
          key={key}
          label={item.label ? item.label : startCase(item.field)}
          defaultValues={item.defaultValues}
          value={props.values[item.field]}
          subFormHeader={item.formHeader}
          selectedTypes={item.selectedTypes}
          onChange={value => {
            props.setFieldValue(item.field, value);
          }}
          error={
            (props.touched[item.field] && props.errors[item.field]) ||
            (props.errors[item.field] && props.submitCount > 0)
          }
        />
      );
    case 'sub-form':
      return (
        <SubForm
          key={key}
          item={item}
          subFields={item.subFields}
          defaultValues={item.defaultValues}
          required={item.required}
          label={item.label ? item.label : startCase(item.field)}
          subFormHeader={item.formHeader}
          exception={item.exception}
          onChange={value => {
            props.setFieldValue(item.field, value);
          }}
          value={props.values[item.field]}
          requiredFields={item.requiredFields}
          titleKey={item.titleKey}
          info={item.info}
          labelType={item.labelType}
          disabled={item.disabled}
          setErrorCondition={item.setErrorCondition}
        />
      );
    case 'sub-custom-form':
      return (
        <SubCustomForm
          key={key}
          subFields={item.subFields}
          defaultValues={item.defaultValues}
          required={item.required}
          label={item.label ? item.label : startCase(item.field)}
          subFormHeader={item.formHeader}
          onChange={value => {
            props.setFieldValue(item.field, value);
          }}
          value={props.values[item.field]}
          requiredFields={item.requiredFields}
          disabled={item.disabled}
          hide={item.hide}
          info={item.info}
        />
      );
    case 'sub-panel':
      return (
        <SubPanel
          key={key}
          subFields={item.subFields}
          subPanelHeader={item.panelHeader}
          imageRequired={item.imageRequired}
          props={props}
          hidden={item.hidden}
          styleInfo={item.styleInfo}
        />
      );
    case 'address':
      return (
        <Address
          freeSolo={true} // custom address can be added if this is enabled
          autoSelect={true} // has to be added with free solo
          key={key}
          className={cn(styles.textInput, styles.select, styles[item.size])}
          options={item.options}
          name={item.field}
          placeholder={
            item.placeholder
              ? item.placeholder
              : `Enter ${startCase(item.field)}`
          }
          value={props.values[item.field]}
          onChange={value => {
            props.setFieldValue(item.field, value ? value.name : value);
            props.setFieldValue(
              ADDRESS_MARKER.site,
              value ? value.markers : [],
            );
          }}
          required={item.required}
          label={item.label ? item.label : startCase(item.field)}
          onFocus={() => props.setFieldTouched(item.field)}
          info={item.info}
          hidden={item.hidden}
          error={
            (props.touched[item.field] && props.errors[item.field]) ||
            (props.errors[item.field] && props.submitCount > 0
              ? props.errors[item.field]
              : false)
          }
          noOptionsText={item.noOptionsText}
        />
      );

    case 'embedded-form':
      return (
        <EmbeddedForm
          key={key}
          className={cn(
            styles.textInput,
            styles.select,
            styles[item.size],
            styles[item.align],
          )}
          item={item}
          formProps={props}
          componentProps={item.componentProps}
          additionalFields={item.additionalFields}
          archiveDelete={item.archiveDelete}
          deleteReferenceKey={item.deleteReferenceKey}
          onDeleteCallback={item.onDeleteCallback}
          allowDrag={item.allowDrag}
          info={item.info}
        />
      );
    case 'embedded-form-follow-up':
      return (
        <EmbeddedFormFollowup
          key={key}
          className={cn(
            styles.textInput,
            styles.select,
            styles[item.size],
            styles[item.align],
          )}
          item={item}
          formProps={props}
          componentProps={item.componentProps}
          additionalFields={item.additionalFields}
          archiveDelete={item.archiveDelete}
          deleteReferenceKey={item.deleteReferenceKey}
          onDeleteCallback={item.onDeleteCallback}
          allowDrag={item.allowDrag}
          info={item.info}
          showTable={item.showTable}
          setFormikFieldValues={keyValuePairs => {
            for (const key in keyValuePairs) {
              if (Object.hasOwnProperty.call(keyValuePairs, key)) {
                const element = keyValuePairs[key];
                props.setFieldValue(key, element);
              }
            }
          }}
        />
      );
    case 'pre-data-population':
      return (
        <FormDataPopulation
          key={key}
          className={cn(
            styles.textInput,
            styles.select,
            styles[item.size],
            styles[item.align],
          )}
          subFields={item.subFields}
          buttonText={item.label}
          submitCallback={item.submitCallback}
          initialValues={item.initialValues}
          validationSchema={item.validationSchema}
          formHeader={item.formHeader}
        />
      );

    case 'form-tabs':
      return (
        <FormTabs
          key={key}
          className={cn(
            styles.textInput,
            styles[item.size],
            styles[item.align],
          )}
          tabs={item.tabs}
          hideTabsOnly={item.hideTabsOnly}
          activeTab={
            props.values[item.field]
              ? props.values[item.field].activeTab || item.activeTab
              : item.activeTab
          }
          formProps={props}
          id={item.field}
          hidden={item.hidden}
          disabled={item.disabled}
          activeOption={item.activeOption}
        />
      );

    case 'schedule':
      return (
        <Schedule
          key={key}
          className={cn(
            styles.textInput,
            styles[item.size],
            styles[item.align],
          )}
          disabled={item.disabled}
          activeTab={
            props.values.schedule
              ? props.values.schedule.activeTab || item.activeTab
              : item.activeTab
          }
          formProps={props}
          id={item.field}
          formItem={item}
          displayView={item.displayView}
          hideAddSchedule={item.hideAddSchedule}
          editMode={item.editMode}
        />
      );
    case 'multiMediaUpload':
      return (
        <MediaUploadForm
          error={props.submitCount > 0 && props.errors[item.field]}
          fieldName={item.field}
          isImageMandatory={item.required}
          value={props.values[item.field]}
          onChange={images => {
            props.setFieldValue(item.field, images);
          }}
          label={item?.label ? item.label : 'Detailed Images'}
          formProps={props}
          mediaLabel={item?.mediaLabel ? item.mediaLabel : 'Media'}
          mediaHeader={item?.mediaHeader}
          mediaType={item?.mediaType}
          disabled={item.disabled}
          sizeOfAudio={item.sizeOfAudio}
          noOfMediaFilesAllowed={item.noOfMediaFilesAllowed}
          key={key}
        />
      );
    case 'table':
      return (
        <Table
          allowEditRow={false}
          allowDeleteRow={false}
          columns={item.columns}
          data={item.dataTransform ? item.dataTransform(item.tableValues) : []}
          allowDrag={false}
          key={key}
        />
      );
    case 'dynamic-text-generator': {
      const error = getNestedValue({ item, data: props.errors });
      const touched = getNestedValue({ item, data: props.touched });
      return (
        <DynamicTextGenerator
          id={id ? `${id}-${item.field}` : item.field}
          label={item.label ? item.label : startCase(item.field)}
          className={cn(styles.textInput, styles[item.size])}
          key={key}
          required={item.required}
          type={item.fieldType}
          field={item.field}
          value={getFieldValue({ item, props, defaultValue: '' })}
          onFocus={() => props.setFieldTouched(item.field)}
          touched={props.touched[item.field]}
          placeholder={
            item.placeholder
              ? item.placeholder
              : `Enter ${startCase(item.field)}`
          }
          error={
            (touched && error) ||
            (error && props.submitCount > 0 ? error : false)
          }
          disabled={item.disabled}
          maxLength={item.maxLength}
          startAdornment={item.startAdornment}
          hidden={item.hidden}
          info={item.info}
          view={item?.view}
          setFieldValue={props?.setFieldValue}
        />
      );
    }
    case 'signature': {
      const error = getNestedValue({ item, data: props.errors });
      const touched = getNestedValue({ item, data: props.touched });
      return (
        <Signature
          label={item.label}
          field={item.field}
          required={true}
          onChange={value => {
            props.setFieldValue(item.field, value);
          }}
          touched={props.touched[item.field]}
          error={
            (touched && error) ||
            (error && props.submitCount > 0 ? error : false)
          }
          key={key}
        />
      );
    }
    case 'evidence-collection': {
      return (
        <CollectEvidence
          columns={item.columns}
          data={item.dataTransform ? item.dataTransform(item.tableValues) : []}
          startTaskCb={item.startTaskCb}
          endTaskCb={item.endTaskCb}
          disableStartButton={item.disableStartButton}
          disableEndButton={item.disableEndButton}
          field={item.field}
          value={props.values[item.field]}
          setFieldValue={props?.setFieldValue}
          disabled={item.disabled}
          key={key}
        />
      );
    }
    default:
      return null;
  }
};

FieldSelection.propTypes = {
  id: PropTypes.string,
  item: PropTypes.object.isRequired,
  key: PropTypes.string.isRequired,
  values: PropTypes.object.isRequired,
  defaultValues: PropTypes.object,
  setFieldTouched: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  errors: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  props: PropTypes.object.isRequired,
  touched: PropTypes.bool.isRequired,
  submitCount: PropTypes.number.isRequired,
  initialValues: PropTypes.object,
  viewName: PropTypes.string,
};

export default FieldSelection;
